module.exports = __webpack_public_path__ + "img/profile-management.3c3f0740.png";